<template>
	<router-view />
</template>
<script>
export default {
	name: "Auth",
};
</script>
